import { BASE_URL } from '../utils/apiUtils';
import { HttpService } from './HttpService';
import CodeMaintenanceService from '../services/CodeMaintenanceService';

export const OffenseService = () => {
	const { get, post, put, deleteFn } = HttpService();
	const { getCodeTypeByName } = CodeMaintenanceService();

	const postOffense = (body) => {
		const url = `${BASE_URL}/api/offense`;
		return post(url, body, 'postOffenseModal', {});
	};

	const getGeneralOffenseCharacter = () => {
		const url = `${BASE_URL}/api/general-offense-character`;
		return get(url, 'getGeneralOffenseCharacter', {});
	};

	const getJuvenileDispositions = (categoryCodeTableId, pageNumber = 0, pageSize = 1000) => {
		const url = `${BASE_URL}/api/disposition-code-management/disposition-codes/Adjudicated/${categoryCodeTableId}?page=${pageNumber}&size=${pageSize}`;
		return get(url, 'getJuvenileDispositions', {});
	};

	const getCjisCodesFiltered = (search, offenseDate, page) => {
		const url = `${BASE_URL}/api/cjis/cjis-codes?filter=${search.toUpperCase()}&offense-date=${offenseDate}&size=25&page=${page}`;
		return get(url, 'getOffenseOptions', {});
	};

	const getCJISCodes = (pageNumber = 0, pageSize = 20) => {
		const url = `${BASE_URL}/api/cjis/cjis-codes?page=${pageNumber}&size=${pageSize}`;
		return get(url, 'CJIS Code', {});
	};

	const getDegrees = () => {
		const url = `${BASE_URL}/api/degree-class`;
		return get(url, 'Degree', {});
	};

	const getArrestingORI = (pageNumber = 0, pageSize = 10, agencyName = '') => {
		const url = `${BASE_URL}/api/offense/arresting-agency-ori?agencyName=${agencyName}&page=${pageNumber}&size=${pageSize}`;
		return get(url, 'ArrestingORI', {});
	};

	const getDispositions = (clerkType = null, pageNumber = 0, pageSize = 1000) => {
		const url = `${BASE_URL}/api/disposition-code-management/disposition-codes?clerk-type=${clerkType}&page=${pageNumber}&size=${pageSize}`;
		return get(url, 'Dispositions', {});
	};

	const getDispositionsByCaseCategoryCodeTableId = (
		categoryCodeTableId,
		pageNumber = 0,
		pageSize = 1000
	) => {
		const url = `${BASE_URL}/api/disposition-code-management/disposition-codes/case-category/${categoryCodeTableId}?page=${pageNumber}&size=${pageSize}`;
		return get(url, 'DispositionsByCaseCategoryCodeTableId', {});
	};

	const getOffensesById = (caseID) => {
		const url = `${BASE_URL}/api/offense/cases/${caseID}`;
		return get(url, 'Offenses', {});
	};

	const getSingleOffenseById = (offenseId) => {
		const url = `${BASE_URL}/api/offense/${offenseId}`;
		return get(url, 'Offense', {});
	};

	const putOffense = (offenseId, body) => {
		const url = `${BASE_URL}/api/offense/${offenseId}`;
		return put(url, body, 'putOffense', {});
	};

	const getOCAColumns = () => {
		const url = `${BASE_URL}/api/oca-management/code-columns`;
		return get(url, 'getOCAColumns', {});
	};

	const getCjisByCode = (code) => {
		const url = `${BASE_URL}/api/cjis/${code}`;
		return get(url, {}, '', {});
	};

	const getUpdateHistory = (offenseId) => {
		const url = `${BASE_URL}/api/offense/${parseInt(offenseId)}/offense-history`;
		return get(url, 'Update History', {});
	};

	const getSentencesByOffenseId = (offenseId) => {
		const url = `${BASE_URL}/api/charge-sentence-management/${offenseId}/charge-sentences`;
		return get(url, 'Offense Sentences', {});
	};

	const getSentencesOptions = async () => {
		let codeTypeRes = await getCodeTypeByName('sentence_type_criminal');

		if (codeTypeRes?.status === 200) {
			let codeTypeData = codeTypeRes?.data;
			return get(
				`${BASE_URL}/api/code-table-management/code-type/${codeTypeData?.codeTypeId}/code-tables`,
				'SentenceOptions',
				{}
			);
		} else {
			return {};
		}
	};

	const getSentencesStatusOptions = async () => {
		let codeTypeRes = await getCodeTypeByName('disposition_cjis_criminal');

		if (codeTypeRes?.status === 200) {
			let codeTypeData = codeTypeRes?.data;

			return get(
				`${BASE_URL}/api/code-table-management/code-type/${codeTypeData?.codeTypeId}/code-tables?page=0&size=50`,
				'SentenceStatusOptions',
				{}
			);
		} else {
			return {};
		}
	};

	const postSentence = (body) => {
		return post(
			`${BASE_URL}/api/charge-sentence-management/charge-sentence`,
			body,
			'postSentence',
			{}
		);
	};

	const deleteOffense = (offenseId) => {
		const url = `${BASE_URL}/api/offense/${offenseId}`;
		return deleteFn(url, 'deleteOffense', {});
	};

	const getOfficer = () => {
		const url = `${BASE_URL}/api/officers`;
		return get(url, 'getOfficer', {});
	};

	const addTickler = (body) => {
		return post(`${BASE_URL}/api/tickler`, body, 'addTickler', {});
	};

	return {
		postOffense,
		getGeneralOffenseCharacter,
		getCjisByCode,
		getCjisCodesFiltered,
		getCJISCodes,
		getDegrees,
		getOffensesById,
		getArrestingORI,
		getDispositions,
		getSingleOffenseById,
		getOCAColumns,
		getUpdateHistory,
		getSentencesByOffenseId,
		getSentencesOptions,
		getSentencesStatusOptions,
		putOffense,
		postSentence,
		deleteOffense,
		getDispositionsByCaseCategoryCodeTableId,
		getJuvenileDispositions,
		getOfficer,
		addTickler
	};
};
